/**
 * @param {*} helathCheckIndex: numeral value
 * @returns level value: low / medium / high
 */
const getHealthCheckLevel = (helathCheckIndex) => {
  let healthChechLevel = "low";
  if (helathCheckIndex >= 75) healthChechLevel = "high";
  else if (helathCheckIndex < 75 && helathCheckIndex >= 35) healthChechLevel = "medium";

  return healthChechLevel;
};

export { getHealthCheckLevel };
